import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Search from "../../assets/Icon/Search.svg";
import close from "../../assets/Icon/close.svg";
import Calender from "../../assets/Icon/calendar.svg";
import DatePicker from "react-datepicker";
import Select from "react-dropdown-select";
import Loader from "../../components/common/Loader";
import Sort from "../../assets/Icon/Short.svg";
import { AddNewCurriculum } from "./AddNewCurriculum";
import ToastHOC from "../HOC/ToastHOC";
import ApiCalling from "../../network/ApiCalling";
import moment from "moment";
import Util from "../../Util";
import { Dropdown } from "react-bootstrap";
import Stack from "@mui/material/Stack";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import Pagination from "@mui/material/Pagination";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ModalComponent from "../Dashbord/ModalComponent";
import Close from "../../assets/Icon/close.png";

const CurriculumFramework = (props) => {
  const { setIsToast, setIsSubToast, isAdmin } = props;
  // console.log(props, isAdmin);
  const [search, setSearch] = useState();
  const [searchClick, setSearchClick] = useState("");
  const [date, setDate] = useState(null);
  const { t } = useTranslation();
  const [statusId, setStatusId] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [sortBy, setSortBy] = useState("");
  const [sortOrder, setSortOrder] = useState(false);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [list, setList] = useState([]);
  const [isCopy, setIsCopy] = useState({});
  const [isEdit, setIsEdit] = useState({});
  const [deleteId, setDeleteId] = useState(0);
  const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
  const school = Util.getSelectedSchool();
  const navigation = useHistory();

  const EnterHandler = (event) => {
    if (event.key === "Enter") {
      setCurrentPage(1);
      setSearchClick(search);
    }
  };

  const searchClicked = () => {
    if (search.length > 0) {
      setSearch("");
      setSearchClick("");
    } else {
      setCurrentPage(1);
      setSearchClick(search);
    }
  };

  const ChangeDate = (date) => {
    setCurrentPage(1);
    setDate(date);
  };

  const changeType = (data) => {
    setCurrentPage(1);
    setStatusId(data[0]?.id);
  };

  const statusList = [
    { id: 1, value: "Active" },
    { id: 2, value: "Inactive" },
  ];

  const CustomInput = React.forwardRef(
    ({ value, onClick, icon, onClear }, ref) => (
      <div className="d-flex" onClick={onClick}>
        <input
          ref={ref}
          className="custom-input__field"
          value={value}
          readOnly
          placeholder="Created On"
        />
        {value ? null : (
          <div className="custom-input__icon">
            <img src={icon} alt="Calendar" className="svg-icon calender-icon" />
          </div>
        )}

        {value && (
          <div
            className="custom-input__icon"
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
          >
            <img
              src={Close}
              alt="Clear"
              className="svg-icon close-icon"
              width={20}
            />
          </div>
        )}
      </div>
    )
  );

  const getFrameworkList = () => {
    setLoading(true);
    if (date) {
      const selectedDate = new Date(date);
      const utcDate = new Date(
        Date.UTC(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate()
        )
      );
      var isoDate = utcDate.toISOString().split("T")[0];
    }

    const data = {
      page_size: recordPerPage,
      page_number: currentPage,
      str_search: search,
      ascdesc: sortOrder ? "asc" : "desc",
      order_by: sortBy,
      created_on: isoDate,
      status: statusId,
      isAdmin: isAdmin,
    };
    // console.log("role", data);
    setLoading(true);
    ApiCalling.apiCallBodyDataPost("assessments/list", data)
      .then((res) => {
        setList(res?.data?.data);
        setTotalPages(res.data.totalPages);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    getFrameworkList();
  }, []);

  useEffect(() => {
    getFrameworkList();
  }, [date, sortBy, sortOrder, search, statusId, recordPerPage, currentPage]);

  const handlePreviousClick = () => {
    if (currentPage !== 1) {
      setCurrentPage((currentPage) => currentPage - 1);
    }
  };

  const handleNextClick = () => {
    if (currentPage !== totalPages) {
      setCurrentPage((currentPage) => currentPage + 1);
    }
  };

  const handleSort = (field) => {
    setSortBy(field);
    setSortOrder(!sortOrder);
  };

  const removeFramework = () => {
    ApiCalling.apiCallDelete(`assessments/curriculum-framework/${deleteId}`)
      .then((res) => {
        if (res.status === 200) {
          setIsToast("Deleted Framework Successfully");
          getFrameworkList();
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setShowDeleteConfirmation(false);
        setDeleteId(0);
      });
  };

  return (
    <>
      <div className="d-flex gap-20 align-items-center table-sort-bar">
        <div className="custom-search-wrap">
          <div className="input-group">
            <input
              className="form-control search"
              placeholder={t("Search Curriculum Framework")}
              type="text"
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
              }}
              onKeyPress={(e) => EnterHandler(e)}
            />
            <div className="input-group-prepend">
              <div className="search-icon">
                <img
                  src={search?.length > 0 ? close : Search}
                  className="svg-icon"
                  alt=""
                  onClick={searchClicked}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mr-2">
          <DatePicker
            placeholderText="Select Date"
            selected={date}
            onChange={ChangeDate}
            peekNextMonth
            showMonthDropdown
            showYearDropdown
            dropdownMode="select"
            popperPlacement="bottom"
            customInput={<CustomInput icon={Calender} />}
            maxDate={new Date()}
            isClearable={true}
          />
        </div>
        <div className="mr-2">
          <Select
            searchable={false}
            className="select-custom text-nowrap"
            options={[{ id: 0, value: "Status" }, ...statusList]}
            onChange={(values) => changeType(values)}
            style={{ width: "100%" }}
            labelField="value"
            values={[{ id: "all", value: "Status" }]}
            valueField="id"
          />
        </div>
        <div className="d-flex justify-content-end align-items-center gap-2 w-25">
          <button
            className="btn primary-sm-btn"
            type="button"
            onClick={() => {
              setIsVisible(true);
              setIsCopy({});
              setIsEdit({});
            }}
          >
            {t("+ Add New")}
          </button>
        </div>
      </div>
      {loading ? (
        <Loader />
      ) : (
        <div className="row">
          <div className="col-lg-12">
            <div className="table-wrapper">
              <table className="table">
                <thead>
                  <tr className="text-nowrap">
                    <th
                      scope="col"
                      className="check-col"
                      style={{
                        width: 0,
                      }}
                    >
                      {t("Name")}
                      <img
                        src={Sort}
                        className="ml-1 fa-sort"
                        alt=""
                        onClick={() => {
                          handleSort("curriculum_framework.name");
                        }}
                      />
                    </th>
                    <th
                      scope="col"
                      className="check-col"
                      style={{
                        width: 0,
                      }}
                    >
                      {t("Status")}
                      <img
                        src={Sort}
                        className="ml-1 fa-sort"
                        alt=""
                        onClick={() => {
                          handleSort("curriculum_framework.status");
                        }}
                      />
                    </th>
                    <th
                      scope="col"
                      className="check-col"
                      style={{
                        width: 0,
                      }}
                    >
                      {t("Created On")}
                      <img
                        src={Sort}
                        className="ml-1 fa-sort"
                        alt=""
                        onClick={() => {
                          handleSort("curriculum_framework.created_on");
                        }}
                      />
                    </th>
                    <th
                      scope="col"
                      className="check-col"
                      style={{
                        width: 0,
                      }}
                    >
                      {t("Action")}
                    </th>
                  </tr>
                </thead>
                {list?.length > 0 ? (
                  <>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td
                              style={{
                                width: 0,
                                cursor: "pointer",
                              }}
                              onClick={() => {
                                setIsVisible(true);
                                setIsCopy({});
                                setIsEdit(item);
                              }}
                            >
                              {item?.name}
                            </td>
                            <td
                              style={{
                                width: 0,
                              }}
                            >
                              {item?.status === 1 ? "Active" : "Inactive"}
                            </td>
                            <td
                              style={{
                                width: 0,
                              }}
                            >
                              {moment(item.created_on).format(
                                Util.getMomentDateTimeFormat(school.date_format)
                              )}
                            </td>
                            <td
                              style={{
                                paddingRight: "0px",
                                width: 0,
                              }}
                            >
                              <Dropdown>
                                <Dropdown.Toggle variant="none">
                                  <button>
                                    <i
                                      className="fa fa-ellipsis-v"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </Dropdown.Toggle>

                                <Dropdown.Menu>
                                  <Dropdown.Item
                                    onClick={(e) => {
                                      e.preventDefault();
                                      navigation.push("/edit-assessment", {
                                        data: item,
                                        isAdmin: isAdmin,
                                      });
                                    }}
                                  >
                                    Edit
                                  </Dropdown.Item>
                                  {isAdmin && (
                                    <Dropdown.Item
                                      onClick={(e) => {
                                        e.preventDefault();
                                        setIsCopy(item);
                                        setIsEdit({});
                                        setIsVisible(true);
                                      }}
                                    >
                                      Copy
                                    </Dropdown.Item>
                                  )}
                                  <Dropdown.Item
                                    onClick={(e) => {
                                      e.preventDefault();
                                      setShowDeleteConfirmation(true);
                                      setDeleteId(item.id);
                                    }}
                                  >
                                    Delete
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </>
                ) : (
                  <>
                    <tfoot>
                      <tr>
                        <td colSpan={8}>
                          {t(
                            "No Templates Found! Please recheck the filter or Create One"
                          )}
                        </td>
                      </tr>
                    </tfoot>
                  </>
                )}
              </table>
            </div>
            {totalPages > 0 && (
              <div className="row m-0 table-footer border-top">
                <div
                  className="d-flex justify-content-between align-items-center"
                  style={{ height: "72px" }}
                >
                  <div className="d-flex align-items-center gap-2">
                    <div className="basic-text">{t("Templates Per Page")}</div>
                    <select
                      style={{ width: "72px", cursor: "pointer" }}
                      className="select-dropdown custom-input"
                      value={recordPerPage}
                      onChange={(e) => {
                        setRecordPerPage(e.target.value);
                      }}
                    >
                      <option value={10}>10</option>
                      <option value={25}>25</option>
                      <option value={50}>50</option>
                      <option value={100}>100</option>
                    </select>
                  </div>

                  <Stack spacing={2} direction="row" alignItems="center">
                    <div
                      className={`link-button ${
                        currentPage === 1 ? "disabled" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        handlePreviousClick();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <KeyboardArrowLeftIcon />
                      <span className="basic-bold-text">{t("Previous")}</span>
                    </div>
                    <Pagination
                      count={totalPages}
                      page={currentPage}
                      onChange={(event, page) => {
                        setCurrentPage(page);
                      }}
                      size="small"
                      hideNextButton
                      hidePrevButton
                    />
                    <div
                      className={`link-button ${
                        currentPage === totalPages ? "disabled" : ""
                      }`}
                      onClick={(e) => {
                        e.preventDefault();
                        handleNextClick();
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <span className="basic-bold-text">{t("Next")}</span>
                      <KeyboardArrowRightIcon />
                    </div>
                  </Stack>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      <AddNewCurriculum
        show={isVisible}
        onClose={() => {
          setIsVisible(false);
        }}
        onSave={() => {
          setIsVisible(false);
          if (Object.keys(isEdit).length === 0) {
            setIsToast("Template Created");
            setIsSubToast("You have successfully added new Template");
          } else {
            setIsToast("Template Updated");
            setIsSubToast("You have successfully upadatedTemplate");
          }
          getFrameworkList();
        }}
        copy={isCopy}
        isAdmin={isAdmin}
        edit={isEdit}
      />
      <ModalComponent
        show={showDeleteConfirmation}
        onHide={() => {
          setShowDeleteConfirmation(false);
        }}
        title={t("Delete")}
        onCancel={t("Cancel")}
        onConfirm={t("Confirm")}
        subTitle={t("Are you sure, to delete this Framework?")}
        size="sm"
        onCancelClick={() => {
          setShowDeleteConfirmation(false);
        }}
        onConfirmClick={removeFramework}
      />
    </>
  );
};

export default ToastHOC(CurriculumFramework);
